import React from 'react';
import { Inbox } from 'lucide-react';

/**
 * The one marker a staged card wears: its ask is sitting in the composer,
 * unsent. Cobalt because the words are the buyer's now — the card stays on the
 * band until their send closes it, so the tag has to say "waiting on you"
 * rather than "done".
 */
const StagedTag: React.FC = () => (
  <span className="inline-flex shrink-0 items-center gap-s2 rounded-pill border border-action-border bg-action-bg px-[9px] py-[3px] text-[10.5px] font-semibold text-action-deep">
    <Inbox className="h-3 w-3" /> In your box
  </span>
);

export default StagedTag;
